// extracted by mini-css-extract-plugin
export var alignBaseline = "_17-9";
export var alignCenter = "_17-5";
export var alignFlexEnd = "_17-7";
export var alignFlexStart = "_17-6";
export var alignSelfBaseline = "_17-e";
export var alignSelfCenter = "_17-a";
export var alignSelfFlexEnd = "_17-c";
export var alignSelfFlexStart = "_17-b";
export var alignSelfStretch = "_17-d";
export var alignStretch = "_17-8";
export var column = "_17-2";
export var columnReverse = "_17-4";
export var flex = "_17-0";
export var justifyCenter = "_17-f";
export var justifyFlexEnd = "_17-h";
export var justifyFlexStart = "_17-g";
export var justifySpaceAround = "_17-j";
export var justifySpaceBetween = "_17-i";
export var justifySpaceEvenly = "_17-k";
export var row = "_17-1";
export var rowReverse = "_17-3";
export var wrapNowrap = "_17-m";
export var wrapWrap = "_17-l";
export var wrapWrapReverse = "_17-n";